import { render, staticRenderFns } from "./PlusMinusIcon.vue?vue&type=template&id=66daabca&scoped=true&"
import script from "./PlusMinusIcon.vue?vue&type=script&lang=js&"
export * from "./PlusMinusIcon.vue?vue&type=script&lang=js&"
import style0 from "./PlusMinusIcon.vue?vue&type=style&index=0&id=66daabca&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../college-and-career-public/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66daabca",
  null
  
)

export default component.exports